<template>
  <el-container class="app-content">
    <el-aside  class="nav-warp"
               width="190px">
      <div class="logo-box">
        <img class="logo"
             src="../../assets/images/logo-hdp.png"
             alt="货代拼logo" />
      </div>
      <!-- <el-button
        style="
          width: 132px;
          height: 36px;
          background: #604aff;
          border-radius: 5px;
          border-color: #604aff;
          margin-bottom: 28px;
        "
        type="primary"
        icon="el-icon-search"
        @click="pathIndex()"
        >查价下单</el-button
      >-->
      <el-menu
        :router="routerType"
        :default-active="path"
        class="app-main__menu"
        @open="handleOpen"
        @close="handleClose"
        @select="pathTo"
      >
        <template v-for="(item, index) in navList">
          <el-submenu :index="index + 1 + ''" :key="index" v-if="item.nextNodes">
              <template slot="title">
                <img :src="menuIcon[item.code]" alt="" style="margin-right: 3px;">
                <span class="menu-one-title">{{ item.name }}</span>
              </template>
              <el-menu-item-group v-for="(_item, _index) in item.nextNodes" :key="_index">
                <el-menu-item :index="_item.code">
                  {{
                  _item.name
                  }}
                </el-menu-item>
              </el-menu-item-group>
          </el-submenu>

          <el-menu-item v-if="!item.nextNodes" :key="index" :index="item.code" style="padding-left: 9px; font-weight: bold; font-size: 16px;">
            <img :src="`${ossPath}/pages/supplierSystem/menu/${item.icon}.png`" alt="" style="margin-right: 3px;">
                {{
                item.name
                }}
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container class="app-content"
                  direction="vertical">
      <div class="app-header header">
        <div class="wrap_l">
          <h1 class="title">货代拼供应商协作系统</h1>
        </div>
        <div class="wrap_R">
          <!-- <div @click="openLogin" v-if="!$store.state.Authorization">
            <div class="loginBtn">快速登录</div>
          </div> -->
          <div v-if="$store.state.Authorization" style="display: flex;align-items: center;">
            <!--<el-link style="margin-right: 10px" type="primary" :underline="false" @click="settledSharedWarehouse">共享仓入驻</el-link>-->
            <!-- <div class="tail-price" @click="toTailPrice">
              <img :src="ossPath + '/pages/supplierSystem/tailPrice/icon_serach_price.png'" alt="">
              <span>尾程查价</span>
            </div> -->
            <el-link style="margin-right: 37px;color: #141414" :underline="false" href="https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/supplier/v1.0.0/pages/home/货代拼供应商端使用手册.pdf" target="_blank">
              <div style="display: flex;align-items: center">
                <img :src="ossPath + '/pages/supplierSystem/tailPrice/icon_guide.png'" alt="" style="width: 16px;height: 16px">
                <span style="font-family: PingFangSC, PingFang SC;">查看操作指南</span>
              </div>
            </el-link>

            <el-dropdown @command="userPathTo" trigger="click">
              <span class="el-dropdown-link">
                {{ $store.state.Authorization.namec }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item command="a">商家中心</el-dropdown-item> -->
                <el-dropdown-item command="c" divided style="min-width: 40px;text-align: center;">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <img :src="ossPath + '/pages/supplierSystem/icon_default_avatar.png'" alt="avatar" style="width: 32px;height: 32px;margin-left: 10px;">
          </div>
        </div>
      </div>
      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view  v-if="!$route.meta.keepAlive"/>
      </el-main>
    </el-container>
  </el-container>

</template>

<script>
import navlistBus from "./components/navlistBus.js";
import {sendCustomerOperationRecord} from "../../assets/js/baseDataRuquest";

export default {
  data () {
    return {
      noTpath: null,
      path: "",
      routerType: true,
      navList: [
        {
          "name": "订单管理",
          "icon": "el-icon-tickets",
          "nextNodes": [
            {
              "name": "FBA头程",
              "code": "/index/PersonalCenter/Personalindex/orderManagement/FBAHeader",
            },
            {
              "name": "按箱维护轨迹",
              "code": "/index/PersonalCenter/Personalindex/orderManagement/trackManagement",
            },
            {
              "name": "干线订单",
              "code": "/index/PersonalCenter/Personalindex/mainOrders/mainOrdersList",
            }
          ]
        },
        {
          "name": "财务管理",
          "icon": "el-icon-money",
          "nextNodes": [
            {
              "name": "我的费用",
              "code": "/index/PersonalCenter/Personalindex/financialManagement/myCost",
            }, {
              "name": "费用调整管理",
              "code": "/index/PersonalCenter/Personalindex/financialManagement/costAdjustmentManagement",
            },
            {
              "name": "我的账单",
              "code": "/index/PersonalCenter/Personalindex/financialManagement/myBill",
            },
            {
              "name": "我的账单 copy",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/billType/PayRecord",
            }
          ]
        },
        {
          "name": "个人资料",
          "icon": "el-icon-user",
          "nextNodes": [
            {
              "name": "发货人",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/SendPage",
            },
            {
              "name": "收货人",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/ReceivePage",
            },
            {
              "name": "提货人",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/PickPage",
            },
            {
              "name": "轨迹推送",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/personalInfo/TrackSetting",
            }
          ]
        },

        {
          "name": "账户管理",
          "icon": "el-icon-setting",
          "nextNodes": [
            {
              "name": "用户管理",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/UserManage",
            },
            {
              "name": "子账号管理",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/SubaccountManage",
            },
            {
              "name": "角色管理",
              "code": "/index/PersonalCenter/Personalindex/PersonalCenter/accountManage/ManagementRole",
            }
          ]
        },
        {
          "name": "报价管理",
          "icon": "el-icon-tickets",
          "nextNodes": [
            // {
            //   "name": "分区管理设置",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/partition",
            // },
            // {
            //   "name": "计费模板设置",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/ChargingTemplate",
            // },
            // {
            //   "name": "派送费设置",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/Delivery",
            // },
            // {
            //   "name": "报关手续费设置",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/DeclareCustoms",
            // },
            // {
            //   "name": "增值服务报价设置",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/Addedservice",
            // },
            // {
            //   "name": "产品报价设置",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/ProductQuotation",
            // },
            {
              "name": "产品报价设置（新）",
              "code": "/index/PersonalCenter/Personalindex/QuotationManagement/productQuotationSetting",
            },
            // {
            //   "name": "物流产品管理",
            //   "code": "/index/PersonalCenter/Personalindex/QuotationManagement/Logistics",
            // }
          ]
        },
        {
          "name": "基础数据",
          "icon": "el-icon-s-data",
          "nextNodes": [
            {
              "name": "仓库管理",
              "code": "/index/PersonalCenter/Personalindex/baseData/warehouseManagement",
            }
          ]
        }
      ],
      menuIcon: {
        '询盘管理': this.ossPath + '/pages/supplierSystem/menu/icon_inquiry.png',
        '平台订单管理': this.ossPath + '/pages/supplierSystem/menu/icon_order.png',
        '个人资料': this.ossPath + '/pages/supplierSystem/menu/icon_personal.png',
        '账号管理': this.ossPath + '/pages/supplierSystem/menu/icon_setting.png',
        '报价管理': this.ossPath + '/pages/supplierSystem/menu/icon_price.png',
        '基础数据': this.ossPath + '/pages/supplierSystem/menu/icon_data.png',
        '费用模版管理': this.ossPath + '/pages/supplierSystem/menu/icon_price.png',
        '尾程报价管理': this.ossPath + '/pages/supplierSystem/menu/icon_price.png',
        '尾程订单管理': this.ossPath + '/pages/supplierSystem/menu/icon_order.png',
        '尾程查价管理': this.ossPath + '/pages/supplierSystem/tailPrice/icon_search_price_cb.png',
      }
    }
  },
  watch: {
    $route: "onRouteChanged",
  },
  methods: {
    hasChildren (children) {


    },
    onRouteChanged () {
      this.path = this.$route.path
    },
    pathIndex () {

      this.$router.push({
        path: "/index/placeOrder/placeIndex",
      })
    },
    handleOpen (key, keyPath) {
      //
      //
    },
    handleClose (key, keyPath) { },
    pathTo (index, indexPath) {
      //
      //
      console.log(index, indexPath)
      this.noTpath = index
      if (!index)
        return this.$message({
          message: "当前业务暂未开放，敬请期待。。。",
          type: "warning",
        })
    },
    userPathTo(command) {
      console.log(command);
      if (command == "a") {
        //个人中心 - 默认首页
        this.$router.push({
          name: "platformSharedWarehouse",
        });
      } else if (command == "b") {
        this.$router.push("/index/placeOrder/placeIndex");
      } else if (command == "c"){
        this.$confirm("确定退出并返回吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            sendCustomerOperationRecord('退出登录', '退出登录')
            setTimeout(() => {
              localStorage.removeItem("Authorization_lineSupplier");
              this.$router.push("/index/placeOrder/placeIndex");
              this.$store.state.Authorization = null;
            }, 100)
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }else if (command == "d"){
        this.$router.push("/index/placeOrder/placeIndex");
      }
    },
    settledSharedWarehouse() {
      this.$router.push({ name: 'platformSharedWarehouse' });
    },
    toTailPrice() {
      this.$router.push({ name: 'queryTailPrice' });
    }
  },
  created () {
    this.onRouteChanged()
    try {
      let user = localStorage.getItem("Authorization_lineSupplier")
      user = JSON.parse(user)
      this.navList = user.authorities
    } catch (e) {
      console.warn('navList 获取异常');
    }
    let authList = []
    authList.push('/')
    authList.push('/index/placeOrder/placeIndex')
    authList.push('/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow')
    if (this.navList.length && this.navList.length > 0) {
      this.navList.forEach(v => {
        v.nextNodes && v.nextNodes.forEach(v2 => {
          authList.push(v2.code)
        })
      })
    }

    // let temp =  sessionStorage.getItem('authList')
    //
  },
  mounted () {
    navlistBus.$on("navlistToindex", (data) => {
      console.log("navlistBus: ", data);
      this.navList = data;
    });
  },
};
</script>
<style scoped lang="scss">
  .app-header,
  .app-content {

  }
  .nav-warp {

  }
  .el-main {
    color: #333;
    background: #EFF1F1;
    padding-top: 10px;
  }
  body > .el-container {
    margin-bottom: 40px;
    height: 100%;
  }
  /* 顶栏*/
  .app-header {
    width: 100%;
    padding: 0 60px 0 40px;
    margin: 0 auto;
    height: 70px;
    min-height: 60px;
    box-sizing: border-box;
    z-index: 9;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    /* justify-content: center; */
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    font-size: 16px;
    background: #FFFFFF;

    .wrap_l {
      display: flex;
      display: -webkit-flex;
      align-items: center;
      cursor: pointer;
      .title{
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
      }
    }
    .wrap_R {
      float: right;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      /* justify-content: center; */
      /* flex-direction: column; */
    }
    /* 登录后 右上角个人信息下拉 */
    .el-dropdown-link {
      cursor: pointer;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #141414;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  /* 侧栏 */
  .logo-box{
    width: 100%;
    margin-bottom: 28px;
    display: flex;
    // justify-content: center;
    .logo {
      display: block;
      border: none;
      width: 127px;
      height: 48px;
      margin-left: 25px;
    }
  }
</style>
<style lang="scss">
  .app-content{
    flex: 1;
    overflow: hidden;
  }
  $--primary-color:#FF4D01;
  $--font-color: #141414;
  .nav-warp {
    padding-top: 36px;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    flex-direction: column;
    background-color: #FFF;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .app-wrap .app-main__menu{
    height: 100%;
    &,
    .el-menu{
      background-color: #FFF;
    }
    width: 100%;
    border-right: none;
    .el-menu-item-group__title {
      padding: 0 !important;
    }
    .el-submenu__title{
      padding: 0 50px;
      padding-left: 9px !important;
      color: $--font-color;
      i,span{
        color: inherit;
      }
      .menu-one-title{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      &:hover,
      &:focus{
        color: #FFF !important;
        background-color: $--primary-color;
      }
    }
    .el-menu-item{
      color: $--font-color;
      &.is-active{
        background-color: $--primary-color;
        color: #FFF;
      }
      &:hover,
      &:focus{
        color: #FFF !important;
        background-color: $--primary-color;
      }
    }
  }

  .el-main{
    height: 100%;
    overflow: auto;
  }
  .tail-price {
    width: 90px;
    height: 30px;
    display: flex;
    align-items: center;
    background: rgba(255, 77, 1, .1);
    border-radius: 3px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D01;
    line-height: 30px;
    margin-right: 36px;
    cursor: pointer;
    user-select: none;
    &:hover {
      background: lighten(rgba(255, 77, 1, .1), 10%);
    }
    img {
      width: 16px;
      height: 16px;
      margin-left: 6px;
      margin-right: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/Personalindex.vue